var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 .5a.75.75 0 01.75.75V3.5a.75.75 0 01-1.5 0V1.25A.75.75 0 017 .5zm0 11.25a.75.75 0 01.75.75v2.25a.75.75 0 11-1.5 0V12.5a.75.75 0 01.75-.75zm6.495-7.5a.75.75 0 01-.274 1.024L11.272 6.4a.75.75 0 11-.75-1.298l1.949-1.126a.75.75 0 011.024.275zM3.753 9.875a.75.75 0 01-.275 1.024L1.53 12.025a.75.75 0 11-.75-1.3l1.948-1.124a.75.75 0 011.025.274zm9.742 1.875a.75.75 0 01-1.024.274L10.522 10.9a.75.75 0 01.75-1.3l1.949 1.126a.75.75 0 01.274 1.024zM3.753 6.125a.75.75 0 01-1.025.274L.78 5.274a.75.75 0 11.75-1.299l1.948 1.126a.75.75 0 01.275 1.024z",
    fill: "#D4D4D8"
  })));
}
export default SvgLoader;